"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorToSpectrumAlias = void 0;
var _color = require("@cbhq/d3/color");
var _between = require("../utils/between");
var _isGray = require("./isGray");
const colorStepMap = {
  minimum: {
    normalText: 60,
    largeText: 60,
    graphic: 50
  },
  enhanced: {
    normalText: 70,
    largeText: 70,
    graphic: 60
  }
};

/**
 * Take a non-CDS color and return the closest equivalent from CDS spectrum colors.
 */
const colorToSpectrumAlias = (color, usage = 'normalText', enhanced) => {
  const step = colorStepMap[enhanced ? 'enhanced' : 'minimum'][usage];
  const hslColor = (0, _color.hsl)(color);
  const hue = Math.round(hslColor.h);
  if ((0, _isGray.isGray)(hslColor)) return 'gray100';
  if (hue === 345 || (0, _between.between)(hue, 0, 14)) return `red${step}`;
  if ((0, _between.between)(hue, 15, 35)) return `orange${step}`;
  if ((0, _between.between)(hue, 36, 80)) return `yellow${step}`;
  if ((0, _between.between)(hue, 81, 180)) return `green${step}`;
  if ((0, _between.between)(hue, 181, 250)) return `blue${step}`;
  if ((0, _between.between)(hue, 251, 289)) return `purple${step}`;
  if ((0, _between.between)(hue, 290, 344)) return `pink${step}`;
  return 'gray100';
};
exports.colorToSpectrumAlias = colorToSpectrumAlias;